module.exports = "/_next/static/images/businessOperations-5600842115148ec50db562b510e7d2ee.webp";